import { ElementType, GlobalConfig } from "../types/builder";

const generateId = (): string => {
  return Math.random().toString(36).substr(2, 9);
};

const createHeaderContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    display: "flex",
    height: "80px",
    padding: "0px 56px",
    justifyContent: "space-between",
    alignItems: "center",
    alignSelf: "stretch",
    borderBottom: "1px solid #DDD",
    background: "rgba(255, 255, 255, 0.90)",
    backdropFilter: "blur(12px)",
  },
  responsiveStyles: {
    tablet: {
      padding: "0px",
      maxWidth: "95%",
      margin: "0 auto",
    },
    mobile: {
      padding: "0px",
      maxWidth: "95%",
      margin: "0 auto",
    },
  },
  children: [
    // Logo
    {
      id: generateId(),
      type: "logo" as ElementType,
      styles: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
      },
      children: [
        {
          id: generateId(),
          type: "image" as ElementType,
          src: "/template3/logo.png", // <-- Update this path to your logo
          alt: "Logo",
          styles: {
            width: "48px",
            height: "48px",
            objectFit: "contain",
          },
        },
      ],
    },
    // Button
    {
      id: generateId(),
      type: "button" as ElementType,
      content: "Jetzt Bestellen",
      styles: {
        display: "flex",
        height: "48px",
        padding: "0px 28px",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
        borderRadius: "60px",
        backgroundColor: "secondary",
        boxShadow: "0px 0px 0px 4px rgba(16, 31, 15, 0.10)",
        color: "#FFFFFF",
        fontWeight: "500",
        fontSize: "18px",
        fontFamily: "Source Serif 4",
        border: "none",
        margin: "0 0 0 auto",
      },
    },
    //Hamburger Button
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "none", // Hidden on desktop
        width: "44px",
        height: "44px",
        borderRadius: "50%",
        backgroundColor: "#F3F3F3",
        border: "none",
        alignItems: "center",
        justifyContent: "center",
        padding: "0",
        cursor: "pointer",
        boxShadow: "0px 2px 8px rgba(0,0,0,0.04)",
        marginLeft: "12px",
      },
      responsiveStyles: {
        tablet: {
          display: "flex",
        },
        mobile: {
          display: "flex",
        },
      },
      children: [
        {
          id: generateId(),
          type: "image" as ElementType,
          src: "/template3/hamburger.svg",
          alt: "avatar1",
          styles: {
            width: "20px",
            height: "20px",
            objectContain: "contain",
            display: "block",
          },
        },
      ],
    },
  ],
});

const createContactSectionContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    maxWidth: "800px",
    margin: "68px auto",
    padding: "0 20px",
    background: "#FFFFFF",
    boxSizing: "border-box",
    textAlign: "center",
  },
  responsiveStyles: {
    tablet: {
      maxWidth: "95%",
      margin: "40px auto",
      padding: "30px 15px",
    },
    mobile: {
      maxWidth: "95%",
      margin: "30px auto",
      padding: "20px 10px",
    },
  },
  children: [
    // Main Title
    {
      id: generateId(),
      type: "heading" as ElementType,
      content: "Kontaktieren Sie uns",
      styles: {
        color: "#000",
        textAlign: "center",
        fontFamily: "Source Serif 4",
        fontSize: "64px",
        fontStyle: "normal",
        fontWeight: "700",
        lineHeight: "normal",
        marginBottom: "20px",
      },
      responsiveStyles: {
        tablet: {
          fontSize: "38px",
        },
        mobile: {
          fontSize: "28px",
        },
      },
    },
    // Subtitle
    {
      id: generateId(),
      type: "text" as ElementType,
      content:
        "Wir sind hier, um Ihnen zu helfen – kontaktieren Sie uns jederzeit.",
      styles: {
        color: "#000",
        textAlign: "center",
        leadingTrim: "both",
        textEdge: "cap",
        textShadow: "0 4px 4px #FFF",
        fontFamily: "Open Sans",
        fontSize: "18px",
        fontStyle: "normal",
        fontWeight: "400",
        lineHeight: "26px",
        marginBottom: "64px",
      },
      responsiveStyles: {
        tablet: {
          marginBottom: "40px",
        },
        mobile: {
          marginBottom: "30px",
        },
      },
    },
    // Contact Methods Container
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        justifyContent: "center",
        marginBottom: "80px",
        width: "100%",
      },
      responsiveStyles: {
        tablet: {
          flexDirection: "column",
          gap: "40px",
          marginBottom: "60px",
        },
        mobile: {
          flexDirection: "column",
          gap: "30px",
          marginBottom: "40px",
        },
      },
      children: [
        // Email Support
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            flex: "1",
            padding: "16px 40px",
            borderRadius: "16px",
            border: "2px solid #396235",
            background:
              "linear-gradient(270deg, rgba(57, 98, 53, 0.10) 1.41%, rgba(87, 151, 115, 0.00) 100%)",
          },
          children: [
            {
              id: generateId(),
              type: "image" as ElementType,
              src: "/template3/mail.png",
              alt: "Email",
              styles: {
                width: "60px",
              },
            },
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "Produkt-E-Mail-Support",
              styles: {
                color: "#000",
                textAlign: "center",
                fontFamily: "Source Serif 4",
                fontSize: "32px",
                fontStyle: "normal",
                fontWeight: "700",
                lineHeight: "normal",
                marginBottom: "8px",
              },
            },
            {
              id: generateId(),
              type: "text" as ElementType,
              content: "support@klosterformel.com",
              styles: {
                color: "#009DFF",
                textAlign: "center",
                fontFamily: "Open Sans",
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: "600",
                lineHeight: "44.5px",
                height: "44.5px",
                marginBottom: "26px",
              },
            },
            {
              id: generateId(),
              type: "text" as ElementType,
              content:
                "*Unser Team antwortet in der Regel innerhalb weniger Stunden",
              styles: {
                color: "#000",
                textAlign: "center",
                leadingTrim: "both",
                textEdge: "cap",
                textShadow: "0 4px 4px #FFF",
                fontFamily: "Open Sans",
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "26px",
              },
            },
          ],
        },
        // Live Chat Support
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            flex: "1",
            padding: "16px 40px",
            borderRadius: "16px",
            border: "2px solid #396235",
            background:
              "linear-gradient(270deg, rgba(57, 98, 53, 0.10) 1.41%, rgba(87, 151, 115, 0.00) 100%)",
          },
          children: [
            {
              id: generateId(),
              type: "image" as ElementType,
              src: "/template3/chat.png",
              alt: "Live Chat",
              styles: {
                width: "60px",
              },
            },
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "Live-Chat-Support",
              styles: {
                color: "#000",
                textAlign: "center",
                fontFamily: "Source Serif 4",
                fontSize: "32px",
                fontStyle: "normal",
                fontWeight: "700",
                lineHeight: "normal",
                marginBottom: "8px",
              },
            },
            {
              id: generateId(),
              type: "button" as ElementType,
              content: "Starten Sie den Live-Chat",
              styles: {
                borderRadius: "60px",
                backgroundColor: "#1E291D",
                boxShadow: "0 0 0 4px rgba(57, 98, 53, 0.10)",
                display: "flex",
                width: "auto",
                height: "48px",
                padding: "0 28px",
                justifyContent: "center",
                alignItems: "center",
                gap: "8px",
                color: "#FFF",
                fontFamily: "Open Sans",
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "normal",
                marginBottom: "20px",
              },
            },
            {
              id: generateId(),
              type: "text" as ElementType,
              content: "*Live Chat Support rund um die Uhr",
              styles: {
                color: "#000",
                textAlign: "center",
                leadingTrim: "both",
                textEdge: "cap",
                textShadow: "0 4px 4px #FFF",
                fontFamily: "Open Sans",
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "26px",
              },
            },
          ],
        },
      ],
    },
  ],
});

const createFaqSectionContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    backgroundColor: "background",
    padding: "50px 0",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    boxSizing: "border-box",
  },
  responsiveStyles: {
    tablet: {
      maxWidth: "95%",
      padding: "30px 0",
      margin: "0 auto",
    },
    mobile: {
      maxWidth: "95%",
      padding: "20px 0",
      margin: "0 auto",
    },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        backgroundColor: "background",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        marginBottom: "60px",
        boxSizing: "border-box",
      },
      responsiveStyles: {
        tablet: {
          marginBottom: "20px",
        },
        mobile: {
          marginBottom: "16px",
        },
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "16px",
            marginBottom: "24px",
          },
          responsiveStyles: {
            tablet: {
              marginBottom: "14px",
            },
            mobile: {
              marginBottom: "10px",
            },
          },
          children: [
            {
              id: generateId(),
              type: "image" as ElementType,
              src: "/template3/faq.png",
              alt: "FAQ",
              styles: {
                width: "32px",
                height: "32px",
                objectContain: "contain",
              },
            },
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "Frequently Asked Questions",
              styles: {
                fontFamily: "Open Sans",
                fontSize: "34px",
                fontWeight: "700",
                lineHeight: "48px",
                color: "secondary",
                textAlign: "center",
              },
              typography: "Heading-3",
              responsiveStyles: {
                tablet: {
                  fontSize: "30px",
                  lineHeight: "32px",
                  textAlign: "left",
                },
                mobile: {
                  fontSize: "26px",
                  lineHeight: "28px",
                  textAlign: "left",
                },
              },
            },
          ],
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            "Bei weiteren Fragen steht unser Support gerne zur Verfügung!",
          styles: {
            fontFamily: "Inter",
            fontSize: "18px",
            fontWeight: "400",
            lineHeight: "32px",
            color: "#3B82F6",
            textAlign: "center",
          },
          typography: "Body",
          responsiveStyles: {
            tablet: {
              lineHeight: "28px",
            },
            mobile: {
              lineHeight: "24px",
            },
          },
        },
      ],
    },
    {
      id: generateId(),
      type: "accordion" as ElementType,
      allowMultiple: false,
      defaultOpen: false,
      accordionType: "single" as "single" | "multiple",
      // Icon configuration for all accordion items
      iconSrcCollapsed: "/template3/plus.svg",
      iconSrcExpanded: "/template3/minus.svg",
      // Icon styling
      iconStyles: {
        width: "24px",
        height: "24px",
        marginLeft: "16px",
      },
      styles: {
        width: "100%",
        maxWidth: "1200px",
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        border: "0",
      },
      children: [
        // FAQ items (collapsible)
        ...[
          {
            q: "Wie lange muss ich das Produkt einnehmen, um erste Ergebnisse zu spüren?",
            a: "Viele Kund:innen berichten über spürbare Verbesserungen nach 7-14 Tagen. Für nachhaltige Ergebnisse empfehlen wir mindestens 90 Tage.",
          },
          {
            q: "Was ist, wenn es bei mir nicht funktioniert?",
            a: "Sollten Sie keine Wirkung verspüren, kontaktieren Sie bitte unseren Support für eine individuelle Beratung.",
          },
          {
            q: "Gibt es bekannte Nebenwirkungen?",
            a: "Das Produkt ist gut verträglich. Bei Unsicherheiten oder Vorerkrankungen sprechen Sie bitte mit Ihrem Arzt.",
          },
          {
            q: "Kann ich das Produkt parallel zu anderen Nahrungsergänzungsmitteln einnehmen?",
            a: "In der Regel ja, aber bei Unsicherheiten oder Medikamenteneinnahme konsultieren Sie bitte Ihren Arzt.",
          },
          {
            q: "Wie nehme ich das Produkt ein?",
            a: "Die empfohlene Einnahme finden Sie auf dem Etikett. In der Regel 2 Kapseln täglich mit ausreichend Wasser.",
          },
          {
            q: "Wie viele Kapseln enthält eine Packung?",
            a: "Eine Packung enthält 60 Kapseln – ausreichend für einen Monat.",
          },
          {
            q: "Warum empfehlen so viele das 6-Monats-Paket?",
            a: "Für nachhaltige Ergebnisse und den besten Preis empfehlen wir das 6-Monats-Paket.",
          },
          {
            q: "Gibt es einen Rabatt, wenn ich mehr bestelle?",
            a: "Ja, beim Kauf von 3 oder 6 Packungen erhalten Sie einen attraktiven Mengenrabatt.",
          },
          {
            q: "Wie läuft der Versand ab?",
            a: "Der Versand erfolgt klimaneutral und in der Regel innerhalb von 1-3 Werktagen.",
          },
          {
            q: "Wohin liefert ihr?",
            a: "Wir liefern innerhalb Deutschlands, nach Österreich und in die Schweiz.",
          },
          {
            q: "Ist die Bezahlung sicher?",
            a: "Ja, alle Zahlungen sind SSL-verschlüsselt und sicher.",
          },
          {
            q: "Gibt es ein Abo oder versteckte Gebühren?",
            a: "Nein, es gibt kein Abo und keine versteckten Kosten.",
          },
          {
            q: "Sind die Kapseln vegan?",
            a: "Ja, unsere Kapseln sind 100% vegan.",
          },
          {
            q: "Wie wird das Produkt hergestellt?",
            a: "Das Produkt wird nach höchsten Qualitätsstandards in Deutschland hergestellt.",
          },
          {
            q: "Was unterscheidet dieses Produkt von anderen?",
            a: "Die einzigartige Rezeptur vereint altes Wissen mit moderner Wissenschaft.",
          },
        ].map((item, idx) => ({
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            border: "none",
            borderRadius: "0",
            borderBottom: "1px solid #EDEDED",
            background: "background",
            padding: "20px 28px",
            display: "flex",
            flexDirection: "column",
            gap: "18px",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
            width: "100%",
            position: "relative", // Added for absolute positioned icon
          },
          responsiveStyles: {
            tablet: {
              padding: "16px",
            },
            mobile: {
              padding: "16px 8px",
            },
          },
          children: [
            // Simple question heading
            {
              id: generateId(),
              type: "heading" as ElementType,
              accordionRole: "question" as const,
              content: `${idx + 1}. ${item.q}`,
              styles: {
                fontFamily: "Open Sans",
                fontSize: "20px",
                fontWeight: "400",
                lineHeight: "147%",
                color: "tertiary",
                margin: "0",
                cursor: "pointer",
                width: "100%",
                display: "flex",
                alignItems: "center",
                padding: "0",
              },
              responsiveStyles: {
                tablet: { fontSize: "18px" },
                mobile: { fontSize: "16px" },
              },
            },
            // Answer element with accordion role
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              accordionRole: "answer" as const,
              content: item.a,
              styles: {
                margin: "0",
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "400",
                lineHeight: "170%",
                color: "#565656",
                width: "100%",
              },
              responsiveStyles: {
                tablet: { fontSize: "14px" },
                mobile: { fontSize: "14px" },
              },
            },
          ],
        })),
      ],
    },
  ],
});

const createMainContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    width: "100%",
    minHeight: "100vh",
  },
  children: [
    createContactSectionContainer(globalConfig),
    createFaqSectionContainer(globalConfig),
  ],
});

export const template3contactUs = (globalConfig: GlobalConfig) => {
  return {
    header: createHeaderContainer(globalConfig),
    main: createMainContainer(globalConfig),
  };
};
